import { FC } from 'react';
import { Link } from 'react-router-dom';
import { localeStore } from 'src/mobx/localesStore';
import './style.scss';

interface IProps {
  title: string;
  description?: string;
  path: string;
}

const Plate: FC<IProps> = ({ title, description, path }) => {
  return (
    <div className="plate">
      <Link className="plate__content" to={path}>
        <p className="plate__title">{localeStore.t(title)}</p>
        {description && <p className="plate__description">{localeStore.t(description)}</p>}
      </Link>
    </div>
  );
};

export default Plate;
